import { FETCH_DASHBOARD_DETAILS } from "../config/types";

const initialState = {
  total_cost: "0",
  total_count: "0",
  total_exp: "0",
  total_pending: "0",
  total_received: "0",
};

const dashboardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_DASHBOARD_DETAILS:
      return { ...state, ...payload };

    default:
      return state;
  }
};

export default dashboardReducer;
